// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".brand[data-v-6388351c]{width:100px}.col1[data-v-6388351c]{padding:.2rem 1rem}header ul li a[data-v-6388351c]{padding-top:.8rem}", ""]);
// Exports
module.exports = exports;
